// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-range {
  --knob-size: 40px;
}
ion-range::part(knob) {
  background: #92e2ba !important;
  box-shadow: 0 3px 1px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.13), 0 0 0 1px rgba(0, 0, 0, 0.02);
}
ion-range::part(bar) {
  background: rgba(0, 0, 0, 0.1) !important;
}
ion-range::part(tick) {
  background: rgba(0, 0, 0, 0.1) !important;
  top: 16px;
  width: 2px;
  height: 10px;
}
ion-range::part(tick-active) {
  top: 16px;
  width: 2px;
  height: 10px;
}

.container-effective-gauge {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.container-content-linear-gauge {
  display: flex;
  flex-direction: column;
}

.gauge-effective-value {
  position: relative;
  top: 7px;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/components/supervision components/gauge/gauge.component.scss","webpack://./src/components/supervision%20components/gauge/gauge.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;ACCJ;ADCI;EACI,8BAAA;EACA,sGAAA;ACCR;ADEI;EACI,yCAAA;ACAR;ADGI;EACI,yCAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;ACDR;ADII;EACI,SAAA;EACA,UAAA;EACA,YAAA;ACFR;;ADMA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;ACHJ;;ADMA;EACI,aAAA;EACA,sBAAA;ACHJ;;ADMA;EACI,kBAAA;EACA,QAAA;EACA,gBAAA;ACHJ","sourcesContent":["ion-range {\n    --knob-size: 40px;\n\n    &::part(knob) {\n        background: #92e2ba!important;\n        box-shadow: 0 3px 1px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.13), 0 0 0 1px rgba(0, 0, 0, 0.02);;\n    }\n\n    &::part(bar)   {\n        background: rgba(0,0,0,.1)!important;\n    }\n\n    &::part(tick) {\n        background: rgba(0,0,0,.1)!important;\n        top: 16px;\n        width: 2px;\n        height: 10px;\n    }\n\n    &::part(tick-active) {\n        top: 16px;\n        width: 2px;\n        height: 10px;\n    }\n}\n\n.container-effective-gauge{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n}\n\n.container-content-linear-gauge{\n    display: flex;\n    flex-direction: column;\n}\n\n.gauge-effective-value{\n    position: relative;\n    top: 7px;\n    font-weight: 600;\n}\n","ion-range {\n  --knob-size: 40px;\n}\nion-range::part(knob) {\n  background: #92e2ba !important;\n  box-shadow: 0 3px 1px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.13), 0 0 0 1px rgba(0, 0, 0, 0.02);\n}\nion-range::part(bar) {\n  background: rgba(0, 0, 0, 0.1) !important;\n}\nion-range::part(tick) {\n  background: rgba(0, 0, 0, 0.1) !important;\n  top: 16px;\n  width: 2px;\n  height: 10px;\n}\nion-range::part(tick-active) {\n  top: 16px;\n  width: 2px;\n  height: 10px;\n}\n\n.container-effective-gauge {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.container-content-linear-gauge {\n  display: flex;\n  flex-direction: column;\n}\n\n.gauge-effective-value {\n  position: relative;\n  top: 7px;\n  font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
